import React from 'react';
import { Link } from 'react-router-dom';

import IconOKX from '../assets/icon-okx.svg';
import IconWalletConnect from '../assets/icon-walletconnect.svg';
import IconPassport from '../assets/icon-passport.svg';

const ConnectExternalWallet = () => {
  const wallets = [
    { id: 'passport', name: 'Passport', icon: IconPassport },
    { id: 'okx', name: 'OKX Wallet', icon: IconOKX },
    { id: 'walletconnect', name: 'Wallet Connect', icon: IconWalletConnect }
  ];

  return (
    <div className="p-4">
      <Link to="/wallet" className="section-title">
        &lt; Go Back
      </Link>

      <h2 className="title mb-2 mt-6">Connect External Wallet</h2>

      <div className='space-y-4'>
        {wallets.map((wallet) => (
          <button
            key={wallet.id}
            className="w-full bg-[#9747ff61] rounded-lg shadow p-4 flex items-center space-x-4"
          >
            <img
              src={wallet.icon}
              alt={wallet.name}
              className="w-8 h-8 invert"
            />
            <span className='font-bold'>{wallet.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ConnectExternalWallet;